import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

import { createAuthActions } from './actions';
import { AuthActions, AuthState } from './types';

export const useAuthStore = create<AuthState & AuthActions>()(
    // persist(
    immer((set, get, store) => ({
        accessToken: null,
        isRefreshing: false,
        referralContext: {
            referralCode: '',
            dubClickId: '',
            resolution: null,
            resolving: false,
        },
        refreshPromise: null,
        ...createAuthActions(set, get, store),
    })),
);
